import {
  TAdminIssuesCounts,
  TAuditedEventsCount,
  TBWTypes,
  TCorePage,
  TEventsCount,
  TKhattabatFunnelStatsData,
  TReceiptCompensationTitles,
  TReport
} from "../Types";
import { Ti18nKeys } from "./i18n";

export const MAX_PROMOCODE_REWARD_IN_HOURS = 100;

export const COMMENTS_DEFAULT_NUMBER = 5;
export const MINIMUM_COMMENT_CHARACTERS = 5;
export const MAXIMUM_COMMENT_CHARACTERS = 500;

export const MAX_NUMBER_OF_COMMENTS = 50;

export const MAXIMUM_PROMOCODE_CHARACTERS = 6;

export const MAX_APP_MESSAGE_LENGTH = 400;
export const DEFAULT_TIME = "1970-01-01 00:00:00";

export const SHOW_TBW_SAVE_BUTTON: TBWTypes[] = [
  "banned",
  "temporary_banned",
  "warning",
  "banned",
  "flagged",
  ""
];

export const SHOW_TBW_INVESTIGATE_BUTTON: TBWTypes[] = [
  "flagged",
  "investigate",
  "temporary_banned",
  ""
];

export const TBW_INVESTIGATE_ONLY: TBWTypes[] = ["investigate"];

export const TBW_INVESTIGATE_WITH_WARN: TBWTypes[] = [
  "",
  "banned",
  "temporary_banned",
  "flagged"
];

export const MAX_ALL_MESSAGES_LIMIT = 200;

export const MAX_TYPED_MESSAGES_LIMIT = 50;

export const ALL_MESSAGES_LOAD_MORE = 200;

export const TYPED_MESSAGES_LOAD_MORE = 100;
export const TEMPORARY_BAN_DEFAULT_DAYS_NUMBER = 5;

export const MINIMUM_REPORTS_BY_TYPE_LIMIT = 5;
export const INVESTIGATION_CASES_LIMIT = 10;

export const MAX_DESCRIPTION_LENGTH = 250;
export const MIN_DESCRIPTION_LENGTH = 25;
export const MAX_PERCENTAGE_VALUE = 100;
export const MIN_PERCENTAGE_VALUE = 70;

export const CUSTOMER_SUPPORT_ROLE = "Customer Support";

export const ISSUES_ARRAY = [
  {
    label: "All",
    value: "all"
  },
  {
    label: "No Issue",
    value: "no_issue"
  },
  { label: "Minor Issue", value: "minor" },
  { label: "Major Issue", value: "major" }
];

export const PROMO_CODE_PAID_OPTION_VALUES = [
  { label: "All", value: "-1" },
  { label: "Not Paid", value: "0" },
  { label: "Paid", value: "1" }
];

export const MAX_NUMBER_ROWS = 100;

export const PROMO_CODE_GENDER_OPTIONS = [
  { label: "All", value: "ALL" },
  { label: "Male", value: "m" },
  { label: "Female", value: "f" }
];

export const PROMO_CODE_ACTIVE_OPTIONS = [
  { label: "Active", value: "1" },
  { label: "Not Active", value: "0" }
];

export const PROMO_CODE_REWARD_TYPE_OPTIONS = [
  { label: "VIP", value: "VIP" },
  { label: "ADVANCED", value: "ADVANCED" },
  { label: "STARTER", value: "STARTER" }
];
export const MAXIMUM_PHONE_NUMBER_DIGITS_ALLOWED = 17;

export const BACK_TO_TOP_PAGES_ARRAY: TCorePage[] = [
  "USER_ADVANCED",
  "USER_MESSAGES",
  "USER_CONVERSATIONS",
  "USER_EVENTS",
  "USER_PAYMENTS"
];

export const SUPERVISOR_RECEIPT_DEFAULT_CONFIGURATION = {
  id: 0,
  descriptionThreshold: 0.0,
  descriptionDiscount: 0.0,
  descriptionPricing: 0.0,
  pictureThreshold: 0.0,
  pictureDiscount: 0.0,
  picturePricing: 0.0,
  reportThreshold: 0.0,
  reportDiscount: 0.0,
  reportPricing: 0.0,
  investigationCasesThreshold: 0.0,
  investigationCasesDiscount: 0.0,
  investigationCasesPricing: 0.0,
  createdOn: `${new Date()}`
};

export const MAXIMUM_NUMBERS_BEFORE_DOT = 4;
export const MAXIMUM_NUMBERS_AFTER_DOT = 2;
export const TWO_DOTS = 2;
export const ONE_DOT = 1;
export const NEGATIVE_VALUE = -1;
export const ZERO_VALUE = 0;
export const SUPERVISOR_SUBMIT_BUTTON_MIN_DATE_ENABLED = 23;
export const SUPERVISOR_SUBMIT_BUTTON_MAX_DATE_ENABLED = 25;
export const PERCENTAGE_CONVERSION_FACTOR = 100;

export const CURRENT_MONTH_CALCULATION_ARRAY: TReceiptCompensationTitles[] = [
  "description",
  "picture",
  "report",
  "investigationCases"
];

export const ADMIN_DEFAULT_ISSUES_COUNT: TAdminIssuesCounts = {
  investigationCaseIssuesCount: 0,
  reportIssuesCount: 0,
  descriptionIssuesCount: 0,
  pictureIssuesCount: 0,
  adminID: 0
};

export const ADMIN_EVENT_COUNTS_DEFAULTS: TEventsCount = {
  reportEventCount: 0,
  investigationCasesEventCount: 0,
  pictureEventCount: 0,
  descriptionEventCount: 0
};

export const ADMIN_AUDITED_EVENT_COUNTS_DEFAULTS: TAuditedEventsCount = {
  reportAuditedCount: 0,
  investigationCasesAuditedCount: 0,
  pictureAuditedCount: 0,
  descriptionAuditedCount: 0
};

export const CONFIGURATION_RECEIPT_DEFAULTS = {
  description: {
    discount: 0,
    price: 0,
    threshold: 0
  },
  picture: {
    discount: 0,
    price: 0,
    threshold: 0
  },
  report: {
    discount: 0,
    price: 0,
    threshold: 0
  },
  investigationCases: {
    discount: 0,
    price: 0,
    threshold: 0
  }
};

export const SUPERVISOR_CURRENT_MONTH_DEFAULTS = {
  id: 0,
  finalSalary: 0,
  description: {
    price: 0,
    discount: 0
  },
  picture: {
    price: 0,
    discount: 0
  },
  report: {
    price: 0,
    discount: 0
  },
  investigationCases: {
    price: 0,
    discount: 0
  }
};

export const DAYS_KEYS: Ti18nKeys[] = [
  "MONDAY",
  "TUESDAY",
  "WEDNESDAY",
  "THURSDAY",
  "FRIDAY",
  "SATURDAY",
  "SUNDAY"
];

export const DEFAULT_REPORT_OBJECT: TReport = {
  status: "pending",
  reportId: 0,
  reason1: 0,
  reason2: 0,
  reason3: 0,
  reason4: 0,
  reason5: 0,
  comment: "",
  reportedOn: "",
  reporterId: 0,
  reporterUUID: "",
  reporterUsername: "",
  reporterGender: "f",
  reporterCreatedOn: "",
  reporterLoginCount: 0,
  reportedId: 0,
  reportedUUID: "",
  reportedUsername: "",
  reportedGender: "f",
  reportedCreatedOn: "",
  reportedLoginCount: 0,
  conversation: {},
  reporterPaid: {
    isReporterPaidVIP: false,
    isReporterPaidPlus: false,
    isReporterPaidAlkhattabat: false,
    isReporterPaidBoost: false,
    isReporterPaidRewind: false,
    isReporterSubscribedVIP: false,
    isReporterSubscribedPlus: false,
    isReporterSubscribedAlkhattabat: false,
    isReporterSubscribedBoost: false,
    isReporterSubscribedRewind: false,
    isReporterPaidSilver: false,
    isReporterPaidGold: false,
    isReporterPaidPlatinum: false,
    isReporterPaidPower: false,
    isReporterSubscribedSilver: false,
    isReporterSubscribedGold: false,
    isReporterSubscribedPlatinum: false,
    isReporterSubscribedPower: false
  },
  reportedPaid: {
    isReportedPaidVIP: false,
    isReportedPaidPlus: false,
    isReportedPaidAlkhattabat: false,
    isReportedPaidBoost: false,
    isReportedPaidRewind: false,
    isReportedSubscribedVIP: false,
    isReportedSubscribedPlus: false,
    isReportedSubscribedAlkhattabat: false,
    isReportedSubscribedBoost: false,
    isReportedSubscribedRewind: false,
    isReportedPaidSilver: false,
    isReportedPaidGold: false,
    isReportedPaidPlatinum: false,
    isReportedPaidPower: false,
    isReportedSubscribedSilver: false,
    isReportedSubscribedGold: false,
    isReportedSubscribedPlatinum: false,
    isReportedSubscribedPower: false
  },
  reporterTempBanCount: 0,
  reportedTempBanCount: 0,
  reporterWarnCount: 0,
  reportedWarnCount: 0,
  reporterTester: false,
  reportedTester: false,
  isReportIndonesianMalaysian: false
};

export const CODE_LENGTH = 6;

export const GENDER_COLORED_TABLE_NAMES = [
  "USER_CONVERSATIONS",
  "USER_MESSAGES",
  "USER_MESSAGE_ID"
];

export const ALLOWED_UPLOADED_IMAGES_TYPES = [".png", ".jpg", ".jpeg", ".gif"];

export const MAX_UPLOADED_IMAGE_SIZE_IN_MB = 0.5;

export const QUALITY_REDUCE_RATIO = 0.8;

export const STANDARD_IMAGE_DEFAULT_SIZE = 1024 * 1024;

export const KHATTABAT_FUNNEL_STATS_DEFAULT_DATA: TKhattabatFunnelStatsData = {
  apply: 0,
  toBeInformed: 0,
  applied: 0,
  doNotInform: 0,
  accepted: 0,
  rejected: 0,
  deleted: 0,
  ongoing: 0,
  paying: 0,
  cancelled: 0,
  refunded: 0,
  active: 0
};
